import { addHours } from "date-fns";
import {
  ClassSession,
  UpcomingClassSession
} from "services/api/sessions/sessionService.types";
import { IUseUpcomingHeroSection } from "./upcoming-class-hero-section.types";

const useUpcomingHeroSection = (
  upcomingClasses: UpcomingClassSession
): IUseUpcomingHeroSection => {
  const { mandatoryClasses = [], extraClasses = [] } = upcomingClasses || {};
  let displayClasses: ClassSession[] = [];
  let sortedClassData = [...mandatoryClasses, ...extraClasses].sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
  );

  sortedClassData.forEach((classObj) => {
    if (!classObj.hasOwnProperty("isOptional")) {
      classObj.isOptional = true;
    }
  });

  if (
    sortedClassData &&
    sortedClassData.length > 1 &&
    sortedClassData[0].isOptional &&
    sortedClassData[1].isOptional &&
    sortedClassData[2]
  ) {
    sortedClassData = [sortedClassData[0], sortedClassData[2]];
  }

  if (
    sortedClassData &&
    sortedClassData[0] &&
    sortedClassData[0].isOptional === false
  ) {
    displayClasses.push(sortedClassData[0]);
  } else if (
    sortedClassData &&
    sortedClassData[0] &&
    sortedClassData[0].isOptional === true
  ) {
    const addHoursToNonMondatory = addHours(
      new Date(sortedClassData[0].endDate),
      2
    ).toISOString();
    if (
      sortedClassData &&
      sortedClassData[1] &&
      sortedClassData[1].isOptional === false &&
      sortedClassData[1].startDate < addHoursToNonMondatory
    ) {
      displayClasses = [sortedClassData[1], sortedClassData[0]];
    } else {
      displayClasses.push(sortedClassData[0]);
    }
  } else if (sortedClassData && sortedClassData[0]) {
    displayClasses.push(sortedClassData[0]);
  }

  return {
    displayClasses: displayClasses.slice(0, 2)
  };
};

export { useUpcomingHeroSection };
